module.exports = __webpack_public_path__ + "static/media/google-maps.363165ba.png";